import React, { Component } from 'react';
import { PropTypes as MobxPropTypes } from 'mobx-react';
import { Col } from 'react-bootstrap';
import { Input, Select } from 'formsy-react-components';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import CompanySelect from '../../../controls/CompanySelect'
import { LogeButtonSlim } from '../../../GeneralStyle'
import moment from 'moment'
import { withRouter } from "react-router-dom";
import styled from 'styled-components'
import Parse from 'parse'

import DayPickerInput from 'react-day-picker/DayPickerInput';


/* Imports for Image Upload Field */
import axios from 'axios'
import Dropzone from 'react-dropzone'
import { DoubleBounce } from 'better-react-spinkit'
import { DropzoneDiv } from '../../../internal/BlackboardBlog/BlackboardStyle'
import config from 'react-global-configuration';

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

export const genderOptions = [
	{ value: "", label: "Geschlecht auswählen..." },
	{ label: "Männlich", value: "M" },
	{ label: "Weiblich", value: "F" }
]

export const clothingSizeOptions = [
	{ value: "", label: "Kleidergröße auswählen..." },
	{ label: "XXS", value: "XXS" },
	{ label: "XS", value: "XS" },
	{ label: "S", value: "S" },
	{ label: "M", value: "M" },
	{ label: "L", value: "L" },
	{ label: "XL", value: "XL" },
	{ label: "XXL", value: "XXL" },
]

// props: updateStateFunction, data,

class MemberInputs extends Component {
  constructor(props) {
    super(props)
    this.state = {
      imageUploading: false,
      imageUploaded: false,
			startDate: moment(),
			resetPwState: 0, // 0: default, 1: loading, 2: error, 3: success
    }
		this.uploadWidget = this.uploadWidget.bind(this)
		this.onDrop = this.onDrop.bind(this)
  }

  uploadWidget(file) {
    let formData = new FormData()

    formData.append('file', file[0])
    formData.append("tags", `theloge, blog`)
    formData.append("upload_preset", config.get("CLOUDINARY_PRESET"))
    formData.append("timestamp", (Date.now() / 1000) | 0)

    axios.post(config.get("CLOUDINARY_UPLOAD_URL"), formData, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    }).then(response => {
      this.props.onChange({
        memberImage: response.data.public_id,
      })
      this.setState({
        imageUploaded: true,
        imageUploading: false
      })
    }).catch(err => {
      console.error("err", err)
    })
  }

  onDrop(acceptedFiles) {
    this.setState({
      imageUploading: true,
      image: acceptedFiles[0],
    });
    this.uploadWidget(acceptedFiles)
    // this.updateStates()
  }

  resetPW = () => {
		this.setState({resetPwState: 1})
		Parse.Cloud.run("resetUserPassword", {userid: this.props.data.objectId}).then(() => {
			this.setState({resetPwState: 3})
		}).catch(() => this.setState({resetPwState: 2}))
  }

	render() {
    const loadingSpinner = (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: 180,
        marginLeft: 30
      }}>
        <DoubleBounce color={"#DAB777"} size={60} />
      </div>
    )

		// const DateInput = ({ value, onClick }) => (
		// 	<div style={{color:"black"}} className="form-group">
		// 		<label className="control-label">Geburtstag</label>
		// 		<input value={value} onClick={onClick} className="form-control" style={{width: "100%"}}/>
		// 	</div>
		// );
		const DateInput = ({ value, onClick }) => {

			let parts = value.split("/")
			value = parts[1]+"/"+parts[0]+"/"+parts[2]

			return (
				<div style={{color:"black"}} className="form-group" style={{padding: 25}}>
					<label className="control-label" style={{color: "#a94442", paddingLeft: 15}}>GEBURTSTAG</label>
					<input value={value} onClick={onClick} className="form-control" style={{width: "100%"}}/>
				</div>
		)}

    let user = this.props.data

		return (
			<div className={'dashboard-form memberInputs'}>
				<Col md={12}>
					<div style={{
						display: 'flex',
						alignItems: 'center',
						marginTop: 20
					}}>
						<Dropzone
							id="dropzone"
							multiple={false}
							accept="image/*"
							onDrop={this.onDrop}
							style={{
								display: 'flex',
								alignItems: 'center',
								height: 180,
								borderRadius: 5,
								flex: 1,
							}}
						>
							{
								this.state.imageUploading ? loadingSpinner : this.state.imageUploaded ? null : <DropzoneDiv
									size={64}
									image={`${config.get('CLOUDINARY_URL')}${user.profileImage || "default-logo_gzpkqk"}.jpg`}
									style={{ margin: '0 0 0 30px', width: 180, height: '100%' }}
								/>
							}
							{
								this.state.imageUploading ? null : this.state.imageUploaded ? <DropzoneDiv
									size={128}
									image={this.state.image.preview}
									style={{ margin: '0 0 0 30px', width: 180, height: '100%' }}
								/> : ''
							}
							<p style={{
								color: 'black',
								margin: '0px 40px 0px 40px',
								cursor: 'pointer'
							}}>
								Klicken um ein Bild hochzuladen
							</p>
						</Dropzone>
					</div>
				</Col>


				<Col md={12}>
					<SectionHeading>Firmeninformationen</SectionHeading>
				</Col>


				{( !this.props.hide || !this.props.hide.includes("CompanySelect") ) && !user.objectId &&
						<Col md={6} >
							<CompanySelect
								name="companyId"
								label="Firma"
								value={user.companyId}
								required={this.props.requiredFields.includes("companyId")}
								onChange={(name, value) => this.props.onChange({user: { ...user, companyId: value }})}
							/>
						</Col>
				}

				{ user.objectId &&
					<Col md={8}>
						<Input
							name="companyId"
							label="Firma"
							value={user.company ? user.company.name : "-"}
							type="text"
							disabled
							// style={{ cursor: "pointer" }}
						/>
					</Col>
				}

				{ user.objectId &&
					<Col md={2} style={{ padding: "35px 0" }}>
						<LogeButtonSlim
							hoverFontColor={"white"}
							style={{width: "100%"}}
							onClick={() => this.props.history.push("/internal/admin/companies/" + user.company.objectId)}>
								Anzeigen
						</LogeButtonSlim>
					</Col>
				}


				<Col md={6}>
					<Input
						name="position"
						label="Position"
						value={user.position}
						type="text"
						required={this.props.requiredFields.includes("position")}
						onChange={(name, value) => this.props.onChange({user: { ...user, position: value }})}
					/>
				</Col>


				<Col md={12}>
					<SectionHeading>Mitgliedsinformationen</SectionHeading>
				</Col>


				<Col md={6}>
					<Input
						name="title"
						label="Titel"
						value={user.title}
						type="text"
						required={this.props.requiredFields.includes("title")}
						onChange={(name, value) => this.props.onChange({user: { ...user, title: value }})}
					/>
				</Col>
				<Col md={12}></Col>
				<Col md={6}>
					<Input
						name="firstname"
						label="Vorname"
						value={user.firstname}
						type="text"
						required={this.props.requiredFields.includes("firstname")}
						onChange={(name, value) => this.props.onChange({user: { ...user, firstname: value }})}
					/>
				</Col>
				<Col md={6}>
					<Input
						name="lastname"
						label="Nachname"
						value={user.lastname}
						type="text"
						required={this.props.requiredFields.includes("lastname")}
						onChange={(name, value) => this.props.onChange({user: { ...user, lastname: value }})}
					/>
				</Col>
				<Col md={6}>
					<Select
						name="gender"
						label="Geschlecht"
						value={user.gender}
						options={genderOptions}
						required={this.props.requiredFields.includes("gender")}
						onChange={(name, value) => this.props.onChange({user: { ...user, gender: value }})}
					/>
				</Col>
				<Col md={6}>
					<Select
						name="clothingSize"
						label="Kleidergröße"
						value={user.clothingSize}
						options={clothingSizeOptions}
						required={this.props.requiredFields.includes("clothingSize")}
						onChange={(name, value) => this.props.onChange({ user: { ...user, clothingSize: value } })}
					/>
				</Col>


				<Col md={6}>
					<DatePicker
						style={{width: "100%", color: "black"}}
        		selected={ user.birthday ? moment(user.birthday, "DD/MM/YYYY") : moment().subtract(20, 'years')}
		        onChange={date => this.props.onChange({user: { ...user, birthday: date.format('DD/MM/YYYY') }})   }
						withPortal
						peekNextMonth
				    showMonthDropdown
				    showYearDropdown
						fixedHeight
						dateFormatCalendar={"MMM YYYY"}
						dropdownMode="select"
      			minDate={moment().subtract(100, 'years')}
						maxDate={moment().subtract(20, 'years')}
						customInput={<DateInput />}
		      />
				</Col>



				<Col md={12}>
					<SectionHeading>Kontakt</SectionHeading>
				</Col>


				<Col md={6}>
					<Input
						name="phone"
						label="Telefonnummer"
						value={user.phone}
						required={this.props.requiredFields.includes("phone")}
						onChange={(name, value) => this.props.onChange({user: { ...user, phone: value }})}
					/>
				</Col>
				<Col md={6}>
					<Input
						name="email"
						label="E-Mail"
						value={user.email}
						type="email"
						required={this.props.requiredFields.includes("email")}
						validations="isEmail"
						onChange={(name, value) => this.props.onChange({user: { ...user, email: value }})}
					/>
				</Col>


				<Col md={12}>
					<SectionHeading>Golf</SectionHeading>
				</Col>


				<Col md={6}>
					<Input
						name="homeGolfCourse"
						label="Heimgolfclub"
						value={user.homeGolfCourse}
						required={this.props.requiredFields.includes("homeGolfCourse")}
						onChange={(name, value) => this.props.onChange({user: { ...user, homeGolfCourse: value }})}
					/>
				</Col>
				<Col md={6}>
					<Input
						name="handicap"
						label="HCP"
						value={user.handicap}
						type="number"
						required={this.props.requiredFields.includes("handicap")}
						onChange={(name, value) => this.props.onChange({user: { ...user, handicap: Number(value) }})}
					/>
				</Col>




				{
					user.objectId &&
					<Col md={12}>
						<SectionHeading>Internes</SectionHeading>
					</Col>
				}
				{
					user.objectId &&
						<Col md={6}>
							<Input
								disabled
								name="objectId"
								label="Object ID"
								value={user.objectId}
								type="text"
							/>
						</Col>
				}

				{ user.objectId &&
					<Col md={3} className="text-center"
						style={{ paddingTop: 35, paddingRight: 45}}>
						<LogeButtonSlim
							style={{ width: "100%"}}
							hoverFontColor={"white"}
							onClick={e => { e.preventDefault(); this.resetPW() }}
						>
							{ this.state.resetPwState == 0 ? "Passwort zurücksetzen" : this.state.resetPwState == 1 ? "Lade..." : this.state.resetPwState == 2 ? "Fehler" : "Erfolgreich"}
						</LogeButtonSlim>
					</Col>
				}
			</div>
		);
	}
}

const SectionHeading = styled.div `
  font-size: 20px;
  margin: 65px 25px 20px 25px;
  padding-bottom: 5px;
  padding-left: 15px;
  color: #212D3D;
	display: block;
  border-bottom: 1px solid #212D3D;
	font-family: "Lora";
`

MemberInputs.propTypes = {
	userStore: MobxPropTypes.observableObject,
	cookies: instanceOf(Cookies).isRequired
};

export default withCookies(withRouter(MemberInputs));



// WEBPACK FOOTER //
// /src/components/admin/Forms/Inputs/MemberInputs.js